<template>
     <div id="affirm-page">

        <div class="jumbotron jumbotron-big text-center" style="background: url(assets/crealco/background-people-team-ujv.jpg); background-size: cover; background-position: left center;">

		<div class="white position-absolute top-0 row h-100 w-100 justify-content-center align-items-center text-center margin-right-left-0">
			<div class="jumbo-info">
				<h1 class="text-uppercase font-xl white text-shadow">WHEN INSPIRATION STRIKES, <br>SAY YES WITH CONFIDENCE—KNOWING<br> YOU'LL NEVER PAY A PENNY<br> MORE THAN YOUR PURCHASE PRICE.</h1> 
			</div>
		</div> 

    	<!--<div class="controllers-cont">
    		<div class="next-section-anchor"><a><i class="material-icons">arrow_downward</i></a>
    		</div>
    	</div>-->

    </div>

    <div class="container pb-1">

    	<h2 class="bd-title section-title default-letter-spacing text-uppercase font-weight-bold font-md text-center">Purchasing your trip with Affirm is easy</h2>

    	<div class="row text-center">    		

    		<div class="col-md-3 mb-2">
    			<div class="bg-gray-200 py-4 rounded-xl" style="min-height: 291px;">
    				<img src="assets/crealco/ico1.png" style="max-width: 130px; width: 100%" class="mx-auto">
    				<h3 class="font-md margin-0">Step 1</h3>
    				<p>Get a quote from your agent and agree on price and itinerary.</p>
    			</div>    		

    		</div>	

    		<div class="col-md-3 mb-2">
    			<div class="bg-gray-200 py-4 rounded-xl" style="min-height: 291px;">
    				<img src="assets/crealco/ico2.png" style="max-width: 130px; width: 100%" class="mx-auto">
    				<h3 class="font-md margin-0">Step 2</h3>
    				<p>Apply to Affirm <a href="https://www.affirm.com/shop/ujvacations" target="_blank">here</a>.</p>
    			</div>
    		</div>	

    		<div class="col-md-3 mb-2">
    			<div class="bg-gray-200 py-4 rounded-xl" style="min-height: 291px;">
    				<img src="assets/crealco/ico3.png" style="max-width: 130px; width: 100%" class="mx-auto">
    				<h3 class="font-md margin-0">Step 3</h3>
    				<p>Choose the way you would like to make payments based on affirm options*.</p>
    			</div>
    		</div>	

    		<div class="col-md-3 mb-2">
    			<div class="bg-gray-200 py-4 rounded-xl" style="min-height: 291px;">
    				<img src="assets/crealco/ico4.png" style="max-width: 130px; width: 100%" class="mx-auto">
    				<h3 class="font-md margin-0">Step 4</h3>
    				<p>Provide your Travel Advisor the credit card number generated and pay for your trip.</p>
    			</div>
    		</div>

    	</div>

    </div>



    <div class="text-center pb-2">

    	<!--<h2 class="bd-title section-title default-letter-spacing font-weight-bold font-lg text-center">Just select <img src="imgs/affirm-logo.png" style="width: 100px; display: inline; vertical-align: text-bottom;"> at check out</h2>-->
        <a href="https://www.affirm.com" target="_blank"><img src="assets/crealco/affirm-logo.png" style="width: 130px;" class="mx-auto my-4 pb-3"></a>    	

    </div>

    <div style="background: url(assets/crealco/background-2-colors.jpg) repeat-y center center;">

    	<section class="container">

    		<div class="row">

    			<div class="col-lg section-style" style="background: #0071bc; margin: 2px 2px 0; display: flex;">

                    <div class="align-middle" style="align-items: center; justify-content: center; display: grid; align-content: center;">
                        <h2 class="bd-title default-letter-spacing text-uppercase font-weight-bold font-md white">SAY YES WITH CONFIDENCE</h2>

                    <p class="white">When you buy with affirm, you always know exactly what you’ll owe and when you’ll be done paying. You’ll never pay a hidden fee-or any fee, for that matter.</p>
                    </div>    				

    			</div>

    			<div class="col-lg section-style align-middle" style="background: #212529; margin: 2px 2px 0;">
    				<h2 class="bd-title default-letter-spacing font-weight-bold font-md white">Transparent</h2>
    				<p class="white">Affirm tells you up front the total amount you’ll pay. That number will never
    				go up.</p>

    				<h2 class="bd-title default-letter-spacing font-weight-bold font-md white">Flexible</h2>

    				<p class="white">You choose the payment schedule that works for you.</p>

    				<h2 class="bd-title default-letter-spacing font-weight-bold font-md white">Fair</h2>

    				<p class="white">Affirm won’t charge you late fees or penalties of any kind, ever.</p>

    			</div>

    		</div>    

    	</section>

    </div>

    <section class="container">

    	<div class="row justify-content-md-center">

    		<div class="col-lg-8 py-4 mb-4">

    			<p class="text-center mt-4 d-none">Payment options are offered by Affirm, are subject to an eligibility check, and may not be available in all states. Options depend on your purchase amount, and a down payment may be required. California residents: Affirm Loan Services, LLC is licensed by the Department of Financial Protection and Innovation. Loans are made or arranged pursuant to California Financing Law license 60DB0-111681.</p>

    			<h2 class="bd-title section-title default-letter-spacing font-weight-bold font-md text-center">FREQUENTLY ASKED QUESTIONS</h2>

    			<div style="background: white; padding: 20px; box-shadow: 5px 5px 11px #ccc;" class="mb-4">

    			<h2 class="bd-title default-letter-spacing font-weight-bold font-md">CAN I PAY OFF MY PURCHASE EARLY?</h2>

    			<p>Yes! There’s no penalty for paying early.</p>

    			<h2 class="bd-title default-letter-spacing font-weight-bold font-md">HOW DO I MAKE MY PAYMENTS?</h2>

    			<p>You can make or schedule payments at affirm.com or in the Affirm app for iOS or Android. Affirm will send you email and text reminders before payments are due.</p>

    			<h2 class="bd-title default-letter-spacing font-weight-bold font-md">DOES CHECKING MY ELIGIBILITY AFFECT MY CREDIT SCORE?</h2>

    			<p>No—checking your eligibility won't affect your credit score.</p>

    			<h2 class="bd-title default-letter-spacing font-weight-bold font-md">DO I NEED A MOBILE NUMBER TO USE AFFIRM?</h2>

    			<p>Yes, you’ll need a mobile phone number from the U.S. or U.S. territories. This helps Affirm verify it’s really you who is creating your account and signing in.</p>

    			<h2 class="bd-title default-letter-spacing font-weight-bold font-md">WHERE CAN I LEARN MORE ABOUT AFFIRM?</h2>

    			<p>You can visit their website at <a href="https://www.affirm.com" target="_blank">affirm.com</a>.</p>

    			</div>

                <p class="text-center"><small>* Subject to eligibility. Payment options through Affirm are provided by these lending partners: <a href="https://affirm.com/lenders" target="_blank">affirm.com/lenders</a>.</small></p>

    		</div>

        </div>

    </section>

        <!--<component-quotes-partners></component-quotes-partners>

        <!-- More About Us Section -->
        <!--<section class="section-style text-center">
            <div class="container"
                 data-aos="fade-right"
                 data-aos-offset="100"
                 data-aos-once="true"
                 data-aos-duration="500">
                <h1 class="bd-title section-title default-letter-spacing text-uppercase font-weight-bold font-md">More about UJV</h1>
                <component-more-ujv></component-more-ujv>
            </div>
        </section>-->

        <!-- UJV App Section -->
        <!--<section class="section-style">
            <div class="container padding-right-left-0"
                 data-aos="fade-left"
                 data-aos-offset="100"
                 data-aos-once="true"
                 data-aos-duration="500">
                <div class="row">
                    <div class="col">
                        <component-app-small></component-app-small>
                    </div>
                </div>
            </div>
        </section> -->

        <!-- Agent Details Modal -->
        <!--<div class="modal fade" id="agentModal" tabindex="-1" role="dialog" aria-labelledby="agentModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header modal-header-gradient">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">
                                <i class="material-icons d-none d-md-inline-block">close</i>
                                <i class="material-icons d-md-none">arrow_back</i>
                            </span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <img class="width-100" src="/assets/temp/billy.jpg">
                        <div class="modal-body-content">
                            <div class="row">
                                <div class="col-auto mr-auto">
                                    <h3 class="font-md margin-0">Billy Boronat</h3>
                                    <p>Travel agent</p>
                                    <p>305-830-0200 x <span><strong>470</strong></span></p>
                                </div>
                                <div class="col-auto">
                                    <a href="mailto:" class="font-md link-style d-block"><i class="material-icons">mail</i></a>
                                </div>
                            </div>
                            <hr>
                            <p>
                                St. Barths, Turks & Caicos, Bermuda, Riviera Maya Hey, I’m Byron! I have been privileged enough to
                                experience but a small corner of this planet and it has only left me longing for more. Though a
                                wide range of experiences have contributed to mold the mindset that I maintain today, I can safely
                                say that I’ve had but a taste of life. I have an intense interest in the world around me.
                            </p>
                            <h3 class="font-md">Favorite hotels</h3>
                            <ul class="list-check">
                                <li>Cheval Blanc Saint Barth Isle De France - St. Barths</li>
                                <li>Las Ventanas al Paraiso - Cabo San Lucas</li>
                            </ul>
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <h3 class="font-md">Favorite destinations</h3>
                                    <ul class="list-check">
                                        <li>Botswana</li>
                                        <li>Monaco</li>
                                        <li>Israel</li>
                                        <li>Spain</li>
                                    </ul>
                                </div>
                                <div class="col-12 col-md-6">
                                    <h3 class="font-md">Recently Visited</h3>
                                    <ul class="list-check">
                                        <li>Botswana</li>
                                        <li>Monaco</li>
                                        <li>Israel</li>
                                        <li>Spain</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>-->
    </div>
</template>

<script>

    export default {
        components: { },
    }
</script>

<style lang="scss">
    /** Unique Index Styles **/
    .jumbotron-big{
        background: url(https://s3.amazonaws.com/ujv-crm-storage/Images/Hotels/Pictures/canaves-oia-suites-header-6001969043d63.jpeg) no-repeat;
    }
</style>
